import { NgOptimizedImage } from '@angular/common';
import {
  Component,
  inject
} from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

import { DrawerService } from '../drawer/drawer.service';
import { GalleryComponent } from '../gallery/gallery.component';
import { HoverGradientDirective } from '../shared/directives/hover-gradient.directive';
import { CdnPipe } from '../shared/pipes/cdn.pipe';
import { GlobalService } from '../shared/services/globals.service';
import { ContactComponent } from './contact/contact.component';

@Component({
  selector: 'app-press',
  imports: [
    NgxTolgeeModule,
    HoverGradientDirective,
    NgOptimizedImage,
    ContactComponent,
    CdnPipe
  ],
  templateUrl: './press.component.html'
})
export class PressComponent {
  readonly GalleryComponent = GalleryComponent;
  globalService = inject(GlobalService)
  drawerService = inject(DrawerService)
}
